import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useDropzone, FileRejection, FileError } from 'react-dropzone'

import DragIcon from '../../assets/icons/drag-files-icon.svg'

const Dropzone = ({
  handleClearErrors,
  documentFileToUpload,
  setDocumentFileToUpload,
  handleSetUploadError
}: {
  handleClearErrors: () => void
  documentFileToUpload: Array<File>
  setDocumentFileToUpload: React.Dispatch<React.SetStateAction<Array<File>>>
  handleSetUploadError: (uploadErrors: Array<FileError>) => void
}) => {
  const { t } = useTranslation(['upload-document-process'])

  const onDrop = useCallback((acceptedFiles: Array<File>, rejectedFiles: Array<FileRejection>) => {
    handleClearErrors()

    if (acceptedFiles?.length) {
      const fileToUpload = acceptedFiles[0]
      setDocumentFileToUpload([fileToUpload])
      return
    }

    handleSetUploadError(rejectedFiles[0].errors)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'text/csv': ['.csv'],
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx']
    },
    maxSize: 52428800
  })

  return (
    <form>
      <div
        {...getRootProps()}
        className="dropzone"
        style={{ opacity: documentFileToUpload.length > 0 ? '0.5' : '1', pointerEvents: documentFileToUpload.length > 0 ? 'none' : 'all' }}
      >
        <input
          {...getInputProps()}
          disabled={documentFileToUpload.length > 0}
        />
        <img
          src={DragIcon}
          alt="Upload Files"
          className="drag-icon"
        />
        <br />
        {isDragActive ? (
          <p>{t('dropzone.dropYourDocumentHere')}</p>
        ) : (
          <p>
            {t('dropzone.dragYourDocument')} <strong>{t('dropzone.selectFromYourPC')}</strong>
          </p>
        )}
        <span className="dropzone-info">{t('dropzone.fileMaxSizeWarning')}</span>
      </div>
    </form>
  )
}

export default Dropzone
